module.exports = __webpack_public_path__ + "img/jalan.e284f66f.svg";